import { get, set } from 'lodash';
import { minutesToHoursMinutes } from './times';

// eslint-disable-next-line import/prefer-default-export
export const prepareModelTimeForForm =
  (model, keyPath) => set(model, keyPath, minutesToHoursMinutes(get(model, keyPath, 0)));
